/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Construct from 'can/construct/construct';
import can from 'can';
import _ from 'lodash';
import FeedTransport from 'scripts/transports/feed-transport';

const ratingUrl = '/bin/usga/green/rating.{pagePath}.json';

export default Construct.extend({}, can.event).extend({

    getPathName(url) {
        let pathName = '';
        try {
            pathName = url ? new URL(url).pathname : '';
        } catch (err) {
            console.log('Error on parsing URL', url, err);

            const paths = url ? url.split('/content/') : [];
            pathName = paths && paths.length > 0 ? '/content/' + paths.pop() : '';
        }

        pathName = pathName.replace('.html', '') || '';

        return pathName;
    },

    loadRating(pagePath = '') {
        if (!ratingUrl) {
            return;
        }

        let pathName = this.getPathName(pagePath);
        pathName = pathName.split( '\/').join('_');
        const url = can.sub(ratingUrl, {pagePath: pathName});
        return this.fetch(url);
    },

    fetch: function (url) {
        this.dispatch('loading', [true]);
        return FeedTransport.request(url, false)
            .then(data => {
                this.dispatch('data', [data]);
                this.dispatch('loading', [false]);
                return data;
            })
            .fail(error => {
                this.dispatch('error', [error])
            });
    },

    request(url) {
        return FeedTransport.request(url, true)
            .then(data => {
                return [data];
            })
            .fail(error => {
                return can.Deferred().reject(error);
            });
    }
});
